import { useI18nStore } from "@/stores/i18n"
import { useConfigStore } from "@/stores/config"
import { downloadAndUnzipAudioFiles } from "@/services/zipDownloader"
import { useHelpStore } from "@/components/af/Help/help.store"
import detectIncognito from "detectincognitojs"
import { storeToRefs } from "pinia"
import { UAParser } from "ua-parser-js"

import type { QuestionsOptions } from "@/types/s3"

export async function getAudio(options: QuestionsOptions) {
  const { urls } = useConfigStore()
  const { currentLocale } = useI18nStore()
  const { setIsReady } = useHelpStore()
  const { showPrivateSafariTooltip } = storeToRefs(useHelpStore())

  const browser = new UAParser().getResult()

  let result = { isPrivate: false, browserName: browser?.browser?.name ?? "" }
  try {
    result = await detectIncognito()
  } catch {
    // ignore
  }

  let indexedDBAvailable = false
  try {
    indexedDBAvailable = !!window.indexedDB
  } catch {
    // IndexedDB access throws in some private browsing contexts (e.g. iOS Safari)
  }

  if (
    (result.browserName === "Safari" &&
      (result.isPrivate || Number(browser?.browser?.version) < 17)) ||
    !indexedDBAvailable
  ) {
    showPrivateSafariTooltip.value = true
    return
  }

  // Construct the URL for the audio file
  const audioURL = `${urls.assets}/audio/${options.test}/${currentLocale.iso_code}.zip`

  try {
    const dbReady = await downloadAndUnzipAudioFiles(audioURL)
    if (!dbReady) {
      showPrivateSafariTooltip.value = true
      return
    }
    setIsReady(true)
  } catch (err) {
    console.error("Error downloading audio files: ", err)
    throw err
  }
}
